// Admin store module - handles admin panel data, user management, and dashboard stats
export default {
  namespaced: true,

  state: {
    dashboardStats: {
      totalClients: 0,
      activeProjects: 0,
      pendingTasks: 0,
      monthlyRevenue: 0,
    },
    loading: false,
    error: null,
  },

  getters: {
    getDashboardStats: (state) => state.dashboardStats,
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
  },

  mutations: {
    SET_DASHBOARD_STATS(state, stats) {
      state.dashboardStats = stats
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
  },

  actions: {
    async fetchDashboardStats({ commit }) {
      commit("SET_LOADING", true)
      try {
        const response = await fetch("YOUR_PHP_API_URL/admin/dashboard-stats", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        const data = await response.json()

        if (data.success) {
          commit("SET_DASHBOARD_STATS", data.stats)
        }
      } catch (error) {
        console.error("[v0] Error fetching dashboard stats:", error)
      } finally {
        commit("SET_LOADING", false)
      }
    },
  },
}
